import { ExtendedImage } from './image'

export * from './image'

export default ExtendedImage